import { gql } from '@apollo/client';
import { Role } from 'auth';

export interface Input {
  firstName: string;
  lastName: string;
  email: string;
  roles: Role[];
}

export interface Data {
  inviteUser: {
    id: string;
  };
}

export const MUTATION = gql`
  mutation InviteUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $orgId: ID!
    $staffRoles: [UpdateStaffRole]
  ) {
    inviteUser(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        organizationId: $orgId
        staffRoles: $staffRoles
      }
    ) {
      id
    }
  }
`;
